module.exports = "<TextField textarea={true} label=\"Textarea tag\" />\n"